import React, { Component } from 'react';
import 'whatwg-fetch';
import './App.css';
import Form from './Form';
import MessageBoard from './MessageBoard';
import './style.css';




class App extends Component {
  constructor(props) {
    super(props)
    this.headers = {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    };
    this.state = {
      messages: [],
      locale: props.locale,
      countryCode: props.countryCode,
    }

    this.onNewMessage = this.onNewMessage.bind(this);
    this.handleSubmitText = this.handleSubmitText.bind(this)
    this.handleSubmitAudio = this.handleSubmitAudio.bind(this);
    this.onListeningVoiceStart = this.onListeningVoiceStart.bind(this);
    this.onListeningVoiceEnd = this.onListeningVoiceEnd.bind(this);
    this.onLoadingStateChanged = this.onLoadingStateChanged.bind(this);
    this.resetStatus = this.resetStatus.bind(this);
    this.handleOfflineResponse = this.handleOfflineResponse.bind(this);
    this.onRecording = this.onRecording.bind(this);

    this.startIdleTimeout();
  }
  welcome_message = {
    'en': "I'm Lamborghini's first Artificial Intelligence, how can I help you?",
    'it': "Sono la prima Intelligenza Artificiale di Lamborghini, come posso aiutarti?",
    'de': "Ich bin die erste künstliche Intelligenz von Lamborghini, wie kann ich Ihnen helfen?",
    'es': "Soy la primera Inteligencia Artificial de Lamborghini, ¿cómo puedo ayudarte?",
    'fr': "Je suis la première Intelligence Artificielle Lamborghini, comment puis-je vous être utile?",
    'ru': "Я первый Искусственный Интеллект Lamborghini, как я могу помочь?",
    'ja': "私はランボルギーニ初の人工知能、AIです。何をお聞きになりたいですか？",
    'zh-cn': "我是兰博基尼的第一个人工智能，我该如何帮助您？",
  };
  labelShowSuggestions = {
    'en': "Show suggestions",
    it: "Mostra suggerimenti",
    de: "Vorschläge anzeigen",
    "zh-cn": "显示建议",
    ja: "アドバイスを表示する",
    ru: "Показать советы",
    es: "Mostrar sugerencias",
    fr: "Afficher les suggestions"
  }

  backToTop = {
    'en': "Return to the initial suggestions",
    it: "Torna ai suggerimenti iniziali",
    de: "Zu den ersten Vorschlägen zurückkehren",
    "zh-cn": "回到最初的建议",
    ja: "最初のアドバイスに戻る",
    ru: "Вернуться к первоначальным советам",
    es: "Volver a las sugerencias iniciales",
    fr: "Revenir aux suggestions initiales"
  }

  textInputPlaceholder = {
    en: "Hey, ask me something…",
    it: "Ciao, chiedimi qualcosa…",
    de: "Hallo, fragen Sie mich etwas...",
    "zh-cn": "嗨，问我一些事吧......",
    ja: "どうぞ、何かご質問ください...",
    ru: "Эй, спросите у меня что-нибудь ...",
    es: "Pregúnteme algo",
    fr: "Hé, posez-moi une question…"
  }

  secondTip = {
    'en': <span>You can choose one of the suggestions or ask me a question</span>,
    it: <span>Puoi scegliere uno dei suggerimenti o farmi una domanda</span>,
    de: <span>Sie können einen der Vorschläge auswählen oder mir eine Frage stellen</span>,
    "zh-cn": <span>您可以选择其中的一个建议或向我提问</span>,
    ja: <span>アドバイスの一つを選択するか、質問することができます</span>,
    ru: <span>Вы можете выбрать один из советов или задать мне вопрос</span>,
    es: <span>Puedes elegir una de las sugerencias o hacerme una pregunta</span>,
    fr: <span>Vous pouvez choisir l’une des suggestions ou me poser une question</span>
  }

  listening_labels = {
    en: "Listening...",
    it: "In ascolto...",
    de: "Hört zu...",
    "zh-cn": "听...",
    "ja": "聞き取り中...",
    ru: "Слушаю...",
    es: "Escuchando...",
    fr: "Écoute en cours…"
  }
  timeoutID = null;

  initState(locale) {
    this.setState(
      {
        messages: [],
      },
      () => {
        this.setState({
          loading: false,
          listening: false,
          languagesShow: false,
          canRecordVoice: true,
          locale,
          labelShowSuggestions: this.labelShowSuggestions[locale],
          backToTop: this.backToTop[locale],
          messages: [
            {
              sender: 'bot',
              message: this.welcome_message[locale],
              time: this.getTime(),
              scrollToBottom: false
            },
            {
              sender: 'bot',
              message: this.secondTip[locale],
              time: this.getTime(),
              scrollToBottom: false
            }
          ],
          conversationContexts: [],
        },
          () => {
            if (this.props.wizard && this.props.wizard_open) {
              setTimeout(() => { this.onNewMessage({ suggestions: true, scrollToBottom: false }); }, 500)
            }
          }
        );
      }
    );
  }

  componentWillReceiveProps(newProps) {
    this.setState({
      hello: newProps.myvar
    })
  }
  onNewMessage(newMessage) {
    this.setState((oldState) => ({ ...oldState, messages: [...oldState.messages, newMessage] }))
  }

  resetStatus() {
    this.setState({ conversationContexts: [] })
  }

  handleSubmitText(message, id, oneshot, resetContexts, element, queryType) {
    this.onNewMessage({
      sender: 'user',
      message: message,
      time: this.getTime(),
      scrollToBottom: true
    })
    const cb = () => {
      if (oneshot === true && typeof id === 'string') {
      }
      this.clearIdleTimeout();

      fetch('query', {
        method: "POST",
        headers: this.headers,
        body: JSON.stringify(this.getForm(message, element && element.clientParams, queryType))
      })
        .then(data => data.json())
        .then(data => this.handleSuccess(data))
        .catch(err => this.handleException(err));
    }
    if (resetContexts === true) {
      this.setState({ conversationContexts: [], resetContexts: true }, cb)
    } else {
      cb();
    }
  }

  handleSubmitAudio(audio, options) {
    // do smth
    const formData = this.getForm(null);
    formData.file = audio;
    formData.sampleRate = options.desiredSampRate;
    var self = this;
    this.clearIdleTimeout();

    return fetch('audio', {
      method: "POST",
      headers: this.headers,
      body: JSON.stringify(formData)
    })
      .then(data => data.json())
      .then(data => {
        self.setState({ conversationContexts: data.response.contexts });
        return data;
      });
  }

  startIdleTimeout() {
    if (this.props.checkTimeout === false) {
      return;
    }
    console.debug(this.props.timeoutInterval, "seconds");
    this.timeoutID = window.setTimeout(() => {
      window.parent.postMessage("BOT_TIMED_OUT", "http://lamborghini.staging.lamborghini.nohup.it/chatbot/milano/");
      window.parent.postMessage("BOT_TIMED_OUT", "https://wwww.lamborghini.com/milano/");
      // window.parent.postMessage("BOT_TIMED_OUT", "http://lamborghini.staging.lamborghini.nohup.it/chatbot/milano/");
      this.setState({ canRecordVoice: false })
      console.debug("timeout");
      // }, this.props.timeoutInterval * 1000);
      // quick fix TODO remove
    }, this.props.timeoutInterval * 1000 * 2);
  }

  clearIdleTimeout() {
    window.clearTimeout(this.timeoutID);
    this.startIdleTimeout();
    console.debug("clearIdleTimeout")
  }
  handleSuccess(data) {
    this.setState({ conversationContexts: data.response.contexts, resetContexts: false });
    this.onNewMessage({
      sender: 'bot',
      message: data.response.fulfillmentText,
      time: this.getTime(),
      ...{ ...(data.response.action ? { action: data.response.action } : {}) },
      ...{ ...(data.response.parameters ? { parameters: data.response.parameters } : {}) },
    });

    if (data.response.suggestions) {
      this.onNewMessage({
        suggestions: data.response.suggestions,
        oneshot: true,
        responseId: data.response.responseId,
        ...{ ...(data.response.action ? { action: data.response.action } : {}) },
        ...{ ...(data.response.parameters ? { parameters: data.response.parameters } : {}) },
      });
    }

    if (typeof data.response.outputAudio) {
      ((base64) => {
        setTimeout(() => {
          if (this.sound) {
            this.sound.pause();
          }
          this.sound = new Audio("data:audio/mp3;base64," + base64);

          this.sound.addEventListener("ended", function () {
            // self.click(self.refs.btnStartRecording);
            // self.setListening(true)
            // self.props.onRecording();
          });
          this.sound.play().then(() => {
          }).catch((err) => {
            console.error(err);
          });
        }, 100);
      })(data.response.outputAudio);
    }
  }
  componentDidMount() {
    this.initState(this.state.locale);

    window.addEventListener("message", ((evt) => {
      if (typeof evt.data == 'object') {
        switch (evt.data.type) {
          case 'question': var self = this; setTimeout(() => {
            self.handleSubmitText(evt.data.text, undefined, undefined, true);
          }, 300); break;
          case 'onLocaleChange':
            this.setState({ locale: evt.data.locale });
            this.initState(evt.data.locale); break;
          default: return null;
        }
      }

      if (typeof evt.data == 'string') {
        switch (evt.data) {
          case 'onStartRecording': this.setState({ canRecordVoice: true }); this.startIdleTimeout(); break;
          default: break;
        }
      }
    }), false)

  }
  handleOfflineResponse(element) {
    this.onNewMessage({
      sender: 'bot',
      message: element.response,
      action: element.action,
      parameters: element.parameters
    });
  }

  handleException(err) {
    this.onNewMessage({
      sender: 'bot',
      message: 'I didn\'t understand that'
    });
  }

  getTime() {
    return new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
  }

  getForm(message, clientParams, queryType) {
    return {
      input_text: message,
      input_language: this.state.locale,
      contexts: this.state.conversationContexts,
      cookie: window.location.pathname.split("/s-")[1],
      latitude: this.state.latitude,
      longitude: this.state.longitude,
      countryCode: this.state.countryCode,
      resetContexts: this.state.resetContexts,
      queryType: queryType,
      clientParams
    }
  }
  renderBadge(text) {
    return <div>{text}</div>;
  }

  onListeningVoiceEnd() {
    this.setState({ listening: false, canRecordVoice: true });
  }

  onListeningVoiceStart() {
    this.setState({ listening: true });
  }

  onLoadingStateChanged(loading) {
    this.setState({ loading });
  }

  onRecording() {
    this.clearIdleTimeout();
  }

  locales = {
    it: "Italiano",
    en: "English",
    de: "Deutsch",
    fr: "Française",
    es: "Español",
    ru: "русский",
    ja: "日本人"
  }
  render() {
    return (
      <div className="container-fluid h-100">
        <div className="row justify-content-center h-100" id="chat_text">
          <div className="chat">
            <div className="card" style={{ overflowX: "hidden" }}>
              {this.props.header !== false ? <div className="header">
                <div className="header-logo"></div>
                <div className="back-arrow"></div>
                <div style={{ clear: 'both' }} />
              </div> : null}
              <MessageBoard
                className={this.props.microphone === false && this.props.text === false ? "form_hidden" : ""}
                wizard={this.props.wizard}
                resetStatus={this.resetStatus}
                labelShowSuggestions={this.state.labelShowSuggestions}
                backToTop={this.state.backToTop}
                handleSubmitText={this.handleSubmitText}
                locale={this.state.locale}
                onNewMessage={this.onNewMessage}
                messages={this.state.messages}
                listening={this.state.listening}
                listeningLabel={this.listening_labels[this.state.locale]}
                handleOfflineResponse={this.handleOfflineResponse}
                loading={this.state.loading} />
              {this.props.microphone === true || this.props.text === true ?
                ([<hr key="hr-1" style={{ marginTop: "5vh" }} />,
                <Form
                  key="form"
                  text={this.props.text}
                  canRecordVoice={this.state.canRecordVoice}
                  microphone={this.props.microphone}
                  recording={this.state.recording}
                  onNewMessage={this.onNewMessage}
                  handleSubmitText={this.handleSubmitText}
                  handleSubmitAudio={this.handleSubmitAudio}
                  onListeningVoiceStart={this.onListeningVoiceStart}
                  onListeningVoiceEnd={this.onListeningVoiceEnd}
                  onLoadingStateChanged={this.onLoadingStateChanged}
                  onRecording={this.onRecording}
                  textInputPlaceholder={this.textInputPlaceholder[this.state.locale]}
                  locale={this.state.locale}
                />,
                <hr key="hr-2" />]) : null}
            </div>
            <div className={"slider" + (this.state.languagesShow ? "" : " closed")}>
              {Object.keys(this.locales).filter(locale => locale !== this.state.locale).map((locale => ([
                <div key={locale} onClick={() => this.initState(locale)}>{this.locales[locale]}</div>, <hr key={"hr" + locale} />])))}
            </div>
          </div>
        </div>
      </div>
    );

  }
}

export default App;
